// extracted by mini-css-extract-plugin
export default {"spinner":"m6c6ivJb2__bh6ILoZTM","bounce1":"OWRkvatcJ4KQbDDH3hUm","bounce":"Cf0yl68pkgU1fzPECgKi","bounce2":"qx_e__8CQSY7CZIMZMqk","bounce3":"SiNFJ7MurssG7iJLJZtD"};